module.exports = __webpack_public_path__ + "img/center_frame_bg.c87c1dbf.png";